import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  styled,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FAQContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  maxWidth: 800,
  width: "100%",
  margin: "auto",
  margin:'50px 0'
}));

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  boxShadow: theme.shadows[1],
  "&:not(:last-child)": {
    marginBottom: theme.spacing(2),
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.dark,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const faqs = [
  {
    question: "How do I change my plan?",
    answer: "You can change your plan from your account settings.",
  },
  {
    question: "What happens if I want to cancel?",
    answer: "You can cancel at any time and you will not be billed for subsequent months.",
  },
  // Add more FAQs here...
];

const FAQSection = () => {
  const [search, setSearch] = useState("");

  return (
    <FAQContainer>
      <Typography variant="h4" gutterBottom>
        Frequently Asked Questions
      </Typography>
      <StyledTextField
        label="Search FAQs"
        variant="outlined"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: "20px", width: "100%" }}
      />
      {faqs
        .filter((faq) =>
          faq.question.toLowerCase().includes(search.toLowerCase())
        )
        .map((faq, index) => (
          <StyledAccordion key={index}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{faq.answer}</Typography>
            </AccordionDetails>
          </StyledAccordion>
        ))}
    </FAQContainer>
  );
};

export default FAQSection;